import request from '@/axios'

export interface AdminMenuAccessResponse {
  route_role_grants: Record<string, string[]>
}

export const getAdminMenuAccessApi = () =>
  request.get<AdminMenuAccessResponse>({ url: '/api/admin/menu-access' })

export const putAdminMenuAccessApi = (data: { route_role_grants: Record<string, string[]> }) =>
  request.put<AdminMenuAccessResponse>({ url: '/api/admin/menu-access', data })
